/**
 * Route for `publisher-specific-payout-crud-permission-scope`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PublisherSpecificPayoutCrudPermissionScopePage } from "../features/publisher-specific-payout-crud-permission-scope/PublisherSpecificPayoutCrudPermissionScopePage";

export const publisherSpecificPayoutCrudPermissionScopeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/publisher-specific-payout-crud-permission-scope",
	component: PublisherSpecificPayoutCrudPermissionScopePage,
});

export default publisherSpecificPayoutCrudPermissionScopeRoute;
